import {ValueObject} from '@s-ui/domain'

/**
 * @param {Object} params
 * @param {Number} params.ad_id
 * @param {Number} params.ad_publisher_type_id
 * @param {String} params.ads_name_page
 * @param {String} params.brand
 * @param {Number} params.brand_id
 * @param {Number} params.car_body_id
 * @param {String} params.category_level1
 * @param {Number} params.category_level1_id
 * @param {Number} params.category_level2_id
 * @param {Number} params.category_level3_id
 * @param {Boolean} params.certificated
 * @param {String} params.color
 * @param {Number} params.company_idwas
 * @param {String} params.country_code
 * @param {String} params.event_name
 * @param {String} params.fuel
 * @param {Number} params.fuel_id
 * @param {Number} params.km
 * @param {Number} params.km_max
 * @param {Number} params.km_min
 * @param {String} params.labels
 * @param {String} params.model
 * @param {Number} params.model_id
 * @param {String} params.power
 * @param {Number} params.power_max
 * @param {Number} params.power_min
 * @param {Number} params.price
 * @param {Number} params.price_max
 * @param {Number} params.price_min
 * @param {String} params.region_level2
 * @param {Number} params.region_level2_id
 * @param {String} params.site
 * @param {String} params.vehicle_status
 * @param {Number} params.vehicle_status_id
 * @param {String} params.version
 * @param {Number} params.year
 * @param {Number} params.year_max
 * @param {Number} params.year_min
 * @param {Boolean} params.warranty
 */
export default class AdvertisingValueObject extends ValueObject {}
